import {
  COUPONS_LIST_REQUEST,
  UPDATE_COUPONS_LIST,
  CHANGE_COUPONS_FILTER,
  SHOW_COUPON_EDITOR_MODAL,
  CHANGE_COUPON_EDITOR_VALUES,
  CHANGE_COUPON_STATUS,
  SET_COUPON_EDITOR_ERROR_MESSAGE,
  SET_COUPON_EDITOR_LOADING,
  SHOW_COUPON_TOGGLE_CONFIRMATION,
  SET_COUPON_TOGGLE_LOADING,
  SHOW_COUPON_DETAILS_MODAL,
  SHOW_COUPON_DETAILS_ROUTINE,
  SET_COUPON_DETAILS_LOADING,
  SET_COUPON_DETAILS_VALUES,
  SHOW_COUPON_DETAILS_ERROR_MESSAGE,
  SET_COUPON_DETAILS_LOGS,
  SET_COUPON_EDITOR_DIRTY,
  RESET_EDITOR_MODAL,
  SET_COUPON_DETAILS_LOGS_LOADING,
  CHANGE_COUPON_DETAILS_LOGS_PAGE,
  SET_COUPON_ASSIGN_MERCHANTS_MODAL_SHOWN,
  SET_COUPON_BUSINESS_ID_VALIDATION_RESULT,
} from 'state/actionTypes';
import { createFormAction } from 'redux-form-saga';

export const getCouponsList = (paging, filters) => {
  return {
    type: COUPONS_LIST_REQUEST,
    payload: {
      paging,
      filters,
    },
  };
};

export const updateCouponsList = (list, paging) => ({
  type: UPDATE_COUPONS_LIST,
  payload: { list, paging },
});

export const changeCouponsFilter = filter => ({
  type: CHANGE_COUPONS_FILTER,
  payload: filter,
});

export const showEditorModal = shown => ({
  type: SHOW_COUPON_EDITOR_MODAL,
  payload: shown,
});

export const changeEditorValues = values => ({
  type: CHANGE_COUPON_EDITOR_VALUES,
  payload: values,
});

export const resetEditorModal = () => ({
  type: RESET_EDITOR_MODAL,
});

export const setEditorModalFormDirty = dirty => ({
  type: SET_COUPON_EDITOR_DIRTY,
  payload: dirty,
});

export const changeCouponStatus = (couponCode, action, paging, filters) => ({
  type: CHANGE_COUPON_STATUS,
  payload: { couponCode, action, paging, filters },
});

export const setCouponEditorErrorMessage = message => ({
  type: SET_COUPON_EDITOR_ERROR_MESSAGE,
  payload: message,
});

export const setCouponEditorLoading = isLoading => ({
  type: SET_COUPON_EDITOR_LOADING,
  payload: isLoading,
});

export const showCouponToggleConfirmation = (shown, couponCode, action) => ({
  type: SHOW_COUPON_TOGGLE_CONFIRMATION,
  payload: { shown, couponCode, action },
});

export const setCouponToggleConfirmLoading = isLoading => ({
  type: SET_COUPON_TOGGLE_LOADING,
  payload: isLoading,
});

export const showCouponDetailsModal = shown => ({
  type: SHOW_COUPON_DETAILS_MODAL,
  payload: shown,
});

export const showCouponDetailsRoutine = (
  couponCode,
  logsPageNumber,
  logsPageSize
) => ({
  type: SHOW_COUPON_DETAILS_ROUTINE,
  payload: { couponCode, logsPageNumber, logsPageSize },
});

export const setCouponDetailsLoading = isLoading => ({
  type: SET_COUPON_DETAILS_LOADING,
  payload: isLoading,
});

export const setCouponDetailsLogsLoading = isLoading => ({
  type: SET_COUPON_DETAILS_LOGS_LOADING,
  payload: isLoading,
});

export const changeCouponLogsPage = (couponCode, pageNumber, pageSize) => ({
  type: CHANGE_COUPON_DETAILS_LOGS_PAGE,
  payload: { couponCode, pageNumber, pageSize },
});

export const setCouponDetailsValues = coupon => ({
  type: SET_COUPON_DETAILS_VALUES,
  payload: coupon,
});

export const showCouponDetailsErrorMessage = (shown, message) => ({
  type: SHOW_COUPON_DETAILS_ERROR_MESSAGE,
  payload: { shown, message },
});

export const setCouponDetailsLogs = (
  list,
  pageNumber,
  pageSize,
  totalCount
) => ({
  type: SET_COUPON_DETAILS_LOGS,
  payload: { list, pageNumber, pageSize, totalCount },
});

export const setCouponAssignMerchantsModalShown = shown => ({
  type: SET_COUPON_ASSIGN_MERCHANTS_MODAL_SHOWN,
  payload: shown,
});

export const setCouponBusinessIdValidationResult = data => ({
  type: SET_COUPON_BUSINESS_ID_VALIDATION_RESULT,
  payload: data,
});

export const createCouponForm = createFormAction('CREATE_COUPON_FORM');
